<span
    card-header
    role="button"
    class="font-5 d-flex align-items-center clip3 position-relative me-2 fw-normal primary-gradient-bg-400 primary-text-alt primary-border corner p-2">
    <ng-content></ng-content>
</span>
